import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { formatISO } from "date-fns";

let lastDropdownData = null;
let lastOptions = null;

const initialState = {
  data: [],
  status: 'idle',
  errors: null,
  last_refresh: null,
  api_tries: 0
}

export const fetchDropdowns = createAsyncThunk(
  'dropdown/fetchDropdowns',
  async (accessToken) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/dropdown`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    return response.data.data
  }
)

export const dropdownSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchDropdowns.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchDropdowns.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        state.last_refresh = formatISO(new Date())
        state.api_tries = 0
      })
      .addCase(fetchDropdowns.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
        state.api_tries += 1
      })
  },
})

//TODO: Sadequr will activate this helper function to convert dropdown options to a map for quick lookup
// const createDropdownOptionsMap = (options) => {
//   return options.reduce((acc, option) => {
//     if (option?.code_key) {
//       acc[option.code_key] = option;
//     }
//     return acc;
//   }, {});
// };

export const selectDropdowns = (state) => state.dropdowns
export const selectDropdownOptions = (state) => {
  // Check if we already have computed options for the current state of dropdown data
  if (lastDropdownData === state.dropdowns.data) {
    return lastOptions;
  }

  // If data has changed, recompute the options
  let options = [];
  state.dropdowns.data.forEach((e) => {
    e.dropdown_options.forEach((ie) => {
      options[ie.id] = ie;
    });
  });

  // Update memoized values
  lastDropdownData = state.dropdowns.data;
  lastOptions = options;

  return options;
};
export default dropdownSlice.reducer
